import { internetStatus } from '@/utils/constants';
import { bizmatesApi } from '@/utils/bizmatesApi';

export default {
  namespaced: true,
  state: {
    canReconnect: true,
    connectionProblem: false,
    internetStatus: true,
    internetFailCount: 0,
    refreshed: false,
    isReconnecting: false,
    hasConnectedOnce: false
  },
  mutations: {
    setCanReconnect(state, payload) {
      state.canReconnect = payload;
    },
    setConnectionProblem(state, payload) {
      state.connectionProblem = payload
    },
    setInternetStatus(state, payload) {
      state.internetStatus = payload.type === internetStatus.online;
    },
    setInternetFailCount(state, payload) {
      state.internetFailCount = !payload ? 0 : state.internetFailCount + payload;
      state.internetStatus = !state.internetFailCount;
    },
    setRefreshed(state, payload) {
      state.refreshed = payload;
    },
    setReconnecting(state, payload) {
      state.isReconnecting = !!payload;
    },
    setHasConnectedOnce(state) {
      state.hasConnectedOnce = true;
    }
  },
  getters: {
    showReconnectingOverlay(state, getters, rootState) {
      return state.isReconnecting && state.hasConnectedOnce && !rootState.videoRtc.audioOnly;
    }
  },
  actions: {
     /**
     * Action to update connection problem to true
     *
     * @param {commit} commit
     * @return void
     */
    hasConnectionProblem ({ commit }) {
      commit('setConnectionProblem', true)
    },
    async pingConnection({ commit }) {
      await bizmatesApi.ping()
        .then(() => {
          commit('setInternetFailCount', 0);
        })
        .catch(function () {
          commit('setInternetFailCount', 1);
        });
    }
  }
};
